import { useState, useEffect, useCallback, useRef } from 'react';

import { Input, Button, TreeSelect } from '@douyinfe/semi-ui';
import { PageLayout } from '@/components/pagelay';
import Pagination from '@/components/seo-pagination';
import Link from 'next/link';

import styles from './styles.module.scss';
import cName from 'classnames';

import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import request from '@/utils/request';

export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data: _data } = await request.get(`/getProductList`, {
    headers: {
      lang: context.locale || context.defaultLocale || 'cn',
    },
    params: {
      page: context.query.page || 1,
      limit: 20,
      name: context.query.name || "",
      category_ids: context.query.category_ids || "",
    }
  })
  return {
    props: {
      ...res.props,
      data: _data?.data || null,
    }
  }
}

export default function ProductList({ menuDetail, data }) {
  const router = useRouter();
  const t = useTranslations();

  console.log("数据", menuDetail, data, router);

  const [tabList, setTabList] = useState([
    {
      id: 'category',
      name: t('online.proCate'),
    },
    {
      id: 'name',
      name: t('online.proName')
    }
  ])
  const [tabActice, setTabActice] = useState("category")

  const [selected, setSelected] = useState({
    category_ids: "",
    name: "",
  })

  const getResult = useCallback((query: any) => {
    let _result = []
    if (query?.category_ids) {
      query?.category_ids?.split(',')?.forEach((id: string) => {
        _result.push({
          id: Number(id),
          type: 'category',
          label: menuDetail?.list?.find(item => item.id == id)?.[`name_${router.locale}`]
        })
      });
    }
    if (query?.name) {
      _result.push({
        id: '99999',
        type: "name",
        label: query?.name,
      })
    }
    return _result
  }, [router, menuDetail])

  const [result, setResult] = useState([])

  const getTreeData = useCallback((list: any[]) => {
    return list?.map((item: any) => {
      return {
        key: String(item?.id),
        value: item?.id,
        label: item?.[`name_${router.locale}`],
        children: item?.childlist?.length ? getTreeData(item?.childlist) : [],
      }
    })
  }, [])

  const gotoPage = useCallback((query: any) => {
    query = {
      ...router.query,
      ...query,
    }
    for (let key in query) {
      if (!query[key]) {
        delete query[key];
      }
    }
    router.push(`${router.pathname}?${new URLSearchParams(query).toString()}`)
  }, [router])

  useEffect(() => {
    setTabActice((router.query?.tab as string) || 'category')
    setSelected({
      category_ids: (router.query.category_ids as string) || "",
      name: (router.query.name as string) || "",
    })
    setResult(getResult(router.query))
  }, [router.query])

  return (
    <PageLayout temp='page_crumb'>
      <div className={styles.container}>
        {getHead(menuDetail)}
        <div className={cName(styles.content, 'm-1480')}>
          <div className={styles.filter}>
            <div className={styles.tab}>
              {
                tabList?.map((item: any, index: number) => (
                  <span key={index} className={cName(styles.item, item?.id == tabActice && styles.active)}
                    onClick={() => {
                      if (item.id == tabActice) return
                      gotoPage({
                        category_ids: "",
                        name: "",
                        tab: item?.id,
                        page: 1,
                      })
                    }}>
                    {item?.name}
                  </span>
                ))
              }
            </div>
            <div className={styles.box}>
              {
                tabActice == 'category' && (
                  <TreeSelect
                    className={styles.tree}
                    filterTreeNode
                    multiple
                    placeholder={t('online.proCatePlace')}
                    treeData={getTreeData(menuDetail?.list)}
                    value={selected?.category_ids ? selected?.category_ids?.split(',')?.map((item: string) => Number(item)) : []}
                    onChange={(value) => {
                      setSelected({
                        ...selected,
                        category_ids: value?.join(','),
                      })
                    }}
                  />
                )
              }
              {
                tabActice == 'name' && (
                  <Input
                    className={styles.input}
                    value={selected?.name}
                    placeholder={t('online.proNamePlace')}
                    onChange={(value) => {
                      setSelected({
                        ...selected,
                        name: value,
                      })
                    }}
                  />
                )
              }
              <Button className={styles.search}
                onClick={() => {
                  gotoPage({
                    ...selected,
                    tab: tabActice,
                    page: 1,
                  })
                }}
              ></Button>
            </div>
            <div className={styles.result}>
              <p className={styles.label}>{t('online.result')}</p>
              <ul className={styles.arr}>
                {
                  result?.map((item: any, index: number) => (
                    <li
                      className={styles.item}
                      key={index}
                      onClick={() => {
                        let _query = null;
                        if (item?.type == 'category') {
                          _query = {
                            ...selected,
                            category_ids: result?.filter((itm: any) => itm?.id != item?.id)?.map((itm: any) => itm?.id)?.join(','),
                          }
                        } else {
                          _query = {
                            ...selected,
                            name: "",
                          }
                        }
                        gotoPage({
                          ..._query,
                          tab: tabActice,
                          page: 1,
                        })
                      }}
                    >
                      {item?.label}
                    </li>
                  ))
                }
              </ul>
              <span
                className={styles.reset}
                onClick={() => {
                  gotoPage({
                    category_ids: "",
                    name: "",
                    tab: tabActice,
                    page: 1,
                  })
                }}>
                {t('online.reset')}
              </span>
            </div>
          </div>
          <ul className={styles.list}>
            {
              data?.list?.map((item: any, index: number) => (
                <li key={index}>
                  <Link href={`/online/product/info?id=${item?.id}`}>
                    <a className={styles.item}>
                      <div className={styles.cover}>
                        <img src={item?.image} alt={item?.name} />
                      </div>
                      <div className={styles.info}>
                        <p className={styles.name}>{item?.name}</p>
                        <p className={styles.company}>{item?.company}</p>
                        <div className={styles.other}>
                          <p className={styles.venues}>
                            {t('online.booth')}
                            {item?.booth_num}
                          </p>
                          <p className={styles.cate}>{item?.category_name}</p>
                        </div>
                      </div>
                      {
                        !!item.is_new && <img className={styles.new} src="http://admin.ipbexpo.com/uploads/editor/20250522/1d768871001222bd21322e845a7f2855.png" alt="" />
                      }
                    </a>
                  </Link>
                </li>
              ))
            }
          </ul>
          <div className={styles.pagination}>
            <Pagination
              page={Number(router.query.page || 1)}
              total={data?.total}
              size={data?.per_page}
            />
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
